// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

const userAffiliateCode = localStorage.getItem("userAffiliateCode");
// Define a service using a base URL and expected endpoints
export const kpiSettingsByTypeAPI = createApi({
  reducerPath: "kpiSettingsByTypeAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getKpiSettings: builder.query<any, kpiSettingsArgTypes>({
      query: ({ type, affiliateCode }) => ({
        url: `/am/configkpi/type/${type}/affiliateCode/${affiliateCode}`,
        method: "GET"
      })
    }),
    getConfigKpi: builder.query<any, kpiSettingsArgTypes>({
      query: ({ type }) => ({
        url: `/am/configkpi/type/${type}`,
        method: "GET"
      })
    })
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetKpiSettingsQuery,
  useGetConfigKpiQuery
} = kpiSettingsByTypeAPI;
